import axios from 'axios';
import Endpoints from '../Endpoints';

export const listProductCategories = async (params = {}) => {
  const { data } = await axios.get(Endpoints.ProductCategories.LIST, { params });
  return data?.data || data;
};

export const getProductCategory = async (id) => {
  const { data } = await axios.get(Endpoints.ProductCategories.SINGLE + id);
  return data?.data || data;
};

export const createProductCategory = async (payload) => {
  const { data } = await axios.post(Endpoints.ProductCategories.CREATE, payload);
  return data?.data || data;
};

export const updateProductCategory = async (id, payload) => {
  const { data } = await axios.put(Endpoints.ProductCategories.UPDATE + id, payload);
  return data?.data || data;
};

export const deleteProductCategory = async (id) => {
  const { data } = await axios.delete(Endpoints.ProductCategories.DELETE + id);
  return data?.data || data;
};
